import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import { notify } from '../../utils';
import TextField from '@material-ui/core/TextField';
import { REQUIRED_ERROR } from '../../utils/constants';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Paths } from '../../Routes/routePaths'
import { useHistory, useParams } from "react-router-dom";
import { DeploymentServices } from '../../Services/DeploymentServices';
import CircularProgress from '@material-ui/core/CircularProgress';
import AppLoader from '../../Components/AppLoader';
import { pageTitleStyles } from '../../theme/commonStyles';

const deploymentServices = new DeploymentServices();

const useStyles = makeStyles((theme) => ({
    inputStyle: {
        borderColor: '#838383',
        borderRadius: '25px',
    },
    pageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 16,
        flexWrap: 'wrap',
        margin: '0 0 24px'
    },
    heading: {
        ...pageTitleStyles
    },
    btn: {
        padding: '8px 16px',
        minHeight: 40,
        height: 40,
        fontSize: '13px',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
    },
    cancelBtn: {
        padding: '8px 16px',
        minHeight: 40,
        height: 40,
        background: '#B7B7B7',
        fontSize: '13px',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
        "&:hover": {
            background: "#454343"
        }
    },
    placeBtn: {
        display: 'flex',
        justifyContent: 'end',
        padding: '20px 0',
        marginTop: 20
    }
}));

const initFormState = { name: "", repository: "", description: "" };

const AddDeployment = () => {

    const classes = useStyles();
    const history = useHistory();

    const { id } = useParams();
    const [loading, setLoading] = React.useState(false);
    const [pageLoading, setPageLoading] = React.useState(Boolean(id));
    const [update, setUpdate] = React.useState(false);
    const [formState, setFormState] = React.useState({ ...initFormState });

    React.useEffect(() => {
        if (id) {
            getDeploymentDetails();  
        }
    // The route id is fixed for this mounted create/edit screen.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getDeploymentDetails = async () => {
        try {
            let data = await deploymentServices.getDeploymentDetail(id)

            if (data && data.data[0]) {
                let formData = data.data[0]
                setUpdate(true)
                setFormState({
                    name: formData.name, repository: formData.repository,
                    description: formData.description
                });
            }
        } finally {
            setPageLoading(false);
        }
    }

    const handleInputChange = (evt) => {
        const { name, value } = evt.target;
        setFormState({ ...formState, [name]: value });
    }

    const formValidationCheck = () => {
        if (!formState.name || !formState.repository) {
            notify("error", REQUIRED_ERROR);
            return null;
        }
        return handleFormSubmit();
    }

    const handleFormSubmit = async () => {
        setLoading(true);
        const payload = {...formState};
        const result = update ? await deploymentServices.addDeployment(payload, id) : await deploymentServices.addDeployment(payload)
        if (result && result.status) {
            notify("success", result.message)
            history.push(Paths.Deployments);
        } else {
            setLoading(false)
            notify("error", (result && result.message) ? result.message : 'Something Went Wrong');
        }
    }

    return (
        <Layout>
            <main>
                <div style={{
                    background: "#FFFFFF",
                    boxShadow: "0px 4px 30px rgba(12, 41, 84, 0.1)",
                    borderRadius: 5,
                    padding: 20,
                    minHeight: '80vh'
                }}>
                    {pageLoading ? <AppLoader minHeight={320} /> : (
                    <>
                    <div className={classes.pageHeader}>
                        <Typography
                            variant="subtitle2"
                            className={classes.heading}
                            color="textPrimary">
                            {update ? 'Update Deployment' : 'Create Deployment'}
                        </Typography>
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                label="Name *"
                                name="name"
                                value={formState.name}
                                type="text"
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                label="Repository *"
                                name="repository"
                                value={formState.repository}
                                type="text"
                                onChange={handleInputChange}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                label="Description"
                                name="description"
                                value={formState.description}
                                multiline
                                rows={3}
                                onChange={handleInputChange}
                            />
                        </Grid>
                    </Grid>

                    <div className={classes.placeBtn}>
                        <Button 
                            onClick={() => history.push(Paths.Deployments)} 
                            variant="outlined"
                            color="default" 
                            className={classes.cancelBtn}>
                                Cancel
                        </Button>
                        <Button color="primary" variant="contained" className={classes.btn}
                            onClick={formValidationCheck}>
                            {loading ? <CircularProgress size={15} color="secondary" /> : update ? 'Update' : 'Save'}
                        </Button>
                    </div>
                    </>
                    )}
                </div>
            </main>
        </Layout>
    );
}

export default AddDeployment;
